import styled from 'styled-components';

import { palette } from '@dev/ee-components';

export const MobileHeader = styled.div`
    display: flex;
    margin-bottom: 20px;
    margin-top: 32px;
    justify-content: space-between;
`;

export const MobileSearchContainer = styled.div`
    width: 100%;
    & > div {
        border: 1px solid ${palette.gray[3]};
    }
`;

export const MobileFiltersContainer = styled.div`
    background-color: #fff;
    border-radius: 4px;
    border: 1px solid ${palette.gray[3]};
    margin-left: 8px;
    padding: 11px 11px;
`;

export const SearchInputWrapper = styled.div`
    width: 280px;
`;

export const TableFilters = styled.div`
    display: flex;
    flex-direction: row;
    padding: 25px 48px 34px;
    justify-content: space-between;
`;

export const FiltersWrapper = styled.div`
    display: flex;
    .popoverWrapperDateDropdown {
        margin-right: 16px;
    }
`;